import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, errText } from "../lib/api";
import { toast } from "sonner";
import { Mail } from "lucide-react";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      // Backend always returns 200 — this response is intentionally identical
      // for known and unknown emails to prevent enumeration.
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(errText(err, "Could not send the reset email"));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16 bg-[#F6F5F1]">
      <div className="max-w-md w-full">
        <div className="text-center mb-10">
          <div className="font-mono-eyebrow text-black/50">A private note</div>
          <h1 className="font-serif-display text-5xl leading-none mt-2">Reset your password.</h1>
        </div>
        {sent ? (
          <div data-testid="forgot-sent" className="bg-white border border-black/10 p-8 text-center">
            <Mail className="w-6 h-6 mx-auto mb-4 text-[color:var(--accent)]"/>
            <p className="font-serif-display text-2xl leading-tight">Check your inbox.</p>
            <p className="text-black/60 mt-3 text-sm">
              If an account exists for <b>{email}</b>, we've sent a reset link.
              It expires in 30 minutes.
            </p>
            <Link to="/auth" className="editorial-link font-mono-eyebrow mt-6 inline-block">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white border border-black/10 p-8 space-y-6">
            <p className="text-black/60 text-sm leading-relaxed">
              Enter the email tied to your Atelier account and we'll send a
              secure link to set a new password.
            </p>
            <div>
              <label className="font-mono-eyebrow">Email</label>
              <input
                data-testid="forgot-email"
                required type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="field mt-2"
                placeholder="you@atelier.com"
              />
            </div>
            <button data-testid="forgot-submit" type="submit" disabled={busy} className="btn-ink w-full disabled:opacity-50">
              {busy ? "Sending…" : "Send reset link"}
            </button>
            <div className="text-center pt-4 border-t border-black/10">
              <Link to="/auth" className="editorial-link font-mono-eyebrow">
                Back to sign in
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
